import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorNodeRequest from "~/operatorApplication/ts/service/comet/OperatorNodeRequest";

export default class Ping extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "ping";
    }

    public receive(): void {
        if (OperatorAccountStore.isAuthorized.value) {
            let p: CometOperatorApplication.CometOperatorTokenPongBodyOpenApiModel = {
                token: OperatorAccountStore.tokenId.value
            };
            (new OperatorNodeRequest("/tokenPong"))
                .setBody(p)
                .send();
        }
    }

}